import React from 'react';
import { OptionField, QuestionContainer, TitleField, Text } from './styles';

interface Props {
  listQuestion: any;
}

const ListStyleQuestionSummary: React.FC<Props> = ({ listQuestion }) => {
  const getQuestionText = (): string => {
    const { questionIdComplete, question } = listQuestion;

    if (!questionIdComplete.includes('.')) {
      return question.text;
    }

    const alternativeId = Number(questionIdComplete.split('.')[1]);
    const alternative = question.alternatives.find(
      (item: any) => item.value === alternativeId,
    );

    return alternative?.text;
  };

  return (
    <QuestionContainer>
      <TitleField>
        <Text>
          {listQuestion.customQuestionText !== ''
            ? listQuestion.customQuestionText
            : getQuestionText()}
        </Text>
      </TitleField>
      <OptionField>
        <Text>{listQuestion.result.optionText ?? 'Keine Antwort'}</Text>
      </OptionField>
    </QuestionContainer>
  );
};

export default ListStyleQuestionSummary;
